<div class="skeleton-entry">
  <div class="skeleton-header">
    <div class="skeleton-avatar stencil-shimmer"></div>
    <div class="skeleton-name stencil-shimmer"></div>
  </div>
  <div class="skeleton-contents">
    <div *ngFor="let message of [1, 2]" class="skeleton-content">
      <div class="skeleton-timestamp stencil-shimmer"></div>
      <div class="skeleton-texts">
        <div
          class="skeleton-text stencil-shimmer"
          *ngFor="let line of [1, 2]; let last = last"
          [class.short]="last"
        ></div>
      </div>
    </div>
  </div>
</div>
